export class DataFlowLayout {
  public View: any;

  public Palette: any;

  public Renderer: any;

  public Toolkit: any;
}
